import "./sidebar.css";
import {
  LineStyle,
  Timeline,
  TrendingUp,
  PermIdentity,
  Storefront,
  AttachMoney,
  BarChart,
  MailOutline,
  DynamicFeed,
  ChatBubbleOutline,
  WorkOutline,
  Report,
} from "@material-ui/icons";
import { Link } from "react-router-dom";


const handleLogout = () => {
  localStorage.removeItem('token'); // Clear the token from localStorage
  // You can clear other relevant data if needed
};

export default function Sidebar() {
  return (
    <div className="sidebar">
      <div className="sidebarWrapper">
        <div className="sidebarMenu">
          <h3 className="sidebarTitle">Dashboard</h3>
          <ul className="sidebarList">
            <Link to="/home" className="link">
            <li className="sidebarListItem active">
              <LineStyle className="sidebarIcon" />
              Encoding
            </li>
            </Link>
            <Link to="/decoding" className="link">
            <li className="sidebarListItem ">
              <LineStyle className="sidebarIcon" />
              Decoding
            </li>
            </Link>
            <Link to="/information" className="link">
            <li className="sidebarListItem ">
              <LineStyle className="sidebarIcon" />
              Information
            </li>
            </Link>
            <Link to="/login" className="link" onClick={handleLogout}>
            <li className="sidebarListItem ">
              <Report className="sidebarIcon" />
              Logout
            </li>
            </Link>
          </ul>
        </div>
        
      </div>
    </div>
  );
}